const invoiceColHeads = [
  {"key":"invoiceNumber", "title":"Invoice Number"},
  {"key":"invoiceDate", "title":"Invoice Date"},
  {"key":"invoiceTotal", "title":"Invoice Total"},
  {"key":"action", "title": "Action"},
  {"key":"display", "title":"Display"},
];

const revShareColHeads = [
  {"key": "products", "title": "Products"},
  {"key": "defaultInitialLoadRevShare", "title": "Default Initial Load Rev Share for All Sites"},
  {"key": "defaultRefreshRevShare", "title": "Default Refresh Rev Share for All Sites"}
]

const customRevShareColHeads = [
  {"key": "sites", "title": "Sites"},
  {"key": "products", "title": "Products"},
  {"key": "initialLoadRevShare", "title": "Initial Load Rev Share"},
  {"key": "refreshRevShare", "title": "Refresh Rev Share"}
]

export { invoiceColHeads as INVOICE_COL_HEADS }
export { revShareColHeads as REVSHARE_COL_HEADS }
export { customRevShareColHeads as CUSTOM_REVSHARE_COL_HEADS }